"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GenericTreeReportHeaderConverter_1 = require("../../../report/conversions/GenericTreeReportHeaderConverter");
/**
 * @author Radek Beran
 */


var WindowPerformanceReportHeaderConverter =
/*#__PURE__*/
function (_GenericTreeReportHea) {
  _inherits(WindowPerformanceReportHeaderConverter, _GenericTreeReportHea);

  function WindowPerformanceReportHeaderConverter() {
    _classCallCheck(this, WindowPerformanceReportHeaderConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowPerformanceReportHeaderConverter).apply(this, arguments));
  }

  return WindowPerformanceReportHeaderConverter;
}(GenericTreeReportHeaderConverter_1.GenericTreeReportHeaderConverter);

exports.WindowPerformanceReportHeaderConverter = WindowPerformanceReportHeaderConverter;